// 会员管理 - 会员列表相关

// import * as utils from '@/utils/utils';

import { exportFiles } from '@/utils/utils'
import { Message } from 'antd'
import services from '../services/memberRole.js'

const {
  getMemberList,
  getFilterTypeList,
  getChangeCertList,
  getProvince,
  updateTypeStatus,
  exortDataFile,
  memberChange,
  batchMemberChange,
  memberChangeList,
} = services

const namespace = 'memberRole'

export default {
  namespace,
  state: {
    memberListData: [], // 会员列表数据
    memberTypes: [], // 会员类型
    enterpriseTypeList: [], // 企业类型
    provinceNameValues: [], // 所在地列表
    assoOrgNameList: [], // 服务主体
    provinceList: [], // 省列表
    componenyFiles: [],
    changeCertListData: [], // 换证申请列表数据
    changeMemberList: [],
  },
  reducers: {
    updateState(state, { payload }) {
      return {
        ...state,
        ...payload,
      }
    },
  },
  effects: {
    *getMemberList({ payload, callback }, { call, put }) {
      const res = yield call(getMemberList, { ...payload })
      if (res && res.success) {
        yield put({
          type: 'updateState',
          payload: {
            memberListData: res.data,
          },
        })
        !!callback && callback(res)
      }
    },
    *getFilterTypeList({ payload, callback }, { call, put }) {
      const res = yield call(getFilterTypeList, { ...payload })
      const res2 = yield call(getProvince, { ...payload })
      if (res && res.success) {
        yield put({
          type: 'updateState',
          payload: {
            assoOrgNameList: res.data.assoOrgNameValues,
            enterpriseTypeList: res.data.businessScopes,
            provinceNameValues: res.data.enterpriseTypes,
            memberTypes: res.data.memberTypes || [],
            provinceList: res2.data.regionlist,
          },
        })
        !!callback && callback(res)
      }
    },
    // 换证申请列表
    *getChangeCertList({ payload, callback }, { call, put }) {
      const res = yield call(getChangeCertList, { ...payload })
      if (res && res.success) {
        yield put({
          type: 'updateState',
          payload: {
            changeCertListData: res.data,
          },
        })
        !!callback && callback(res)
      }
    },

    // 导出数据文件
    *exortDataFile({ payload, callback }, { call, put }) {
      const res = yield call(exortDataFile, { ...payload })
      !!callback && callback(res)
      exportFiles(res, payload.fileName)
    },

    // 修改状态
    *updateTypeStatus({ payload, callback }, { call, put }) {
      console.log('updateTypeStatus2')
      const res = yield call(updateTypeStatus, { ...payload })
      if (res && res.success) {
        !!callback && callback(res)
      } else {
        callback && callback()
        Message.error(res.msg || '请求错误，请稍后重试！')
      }
    },

    *memberChange({ payload }, { call }) {
      const res = yield call(memberChange, payload)
      if (res && res.success) {
        payload.resolve?.()
      }
    },

    *batchMemberChange({ payload }, { call }) {
      const res = yield call(batchMemberChange, payload)
      if (res && res.success) {
        payload.resolve?.()
      }
    },

    *memberChangeList({ payload, callback }, { call, put }) {
      const res = yield call(memberChangeList, payload)
      if (res && res.success) {
        yield put({
          type: 'updateState',
          payload: {
            changeMemberList: res.data,
          },
        })
        callback && callback(res)
      }
    },
  },

  // 订阅事件
  subscriptions: {},
}
